import store from '@/store';
import { ConnectorConfig } from '@/models/ConnectorConfig';
import { ConnectorSyncStatus } from '@/store/state/ConnectorState';

export const commitSetConnectors = (connectors: ConnectorConfig[]) => {
  store.commit('setConnectors', connectors);
};
export const commitSetConnectorLoading = (isLoading: boolean) => {
  store.commit('setConnectorLoading', isLoading);
};
export const commitSetConnectorError = (error: string | null) => {
  store.commit('setConnectorError', error);
};
export const commitAddConnector = (connector: ConnectorConfig) => {
  store.commit('addConnector', connector);
};
export const commitRemoveConnector = (connectorId: string) => {
  store.commit('removeConnector', connectorId);
};
export const commitUpdateConnector = (connector: ConnectorConfig) => {
  store.commit('updateConnector', connector);
};
export const commitSetConnectorSyncState = (connectorId: string, syncStatus: ConnectorSyncStatus) => {
  store.commit('setConnectorSyncState', { connectorId, syncStatus });
};
export const commitClearConnectorSyncState = (connectorId: string) => {
  store.commit('clearConnectorSyncState', connectorId);
};
export const commitHydrateConnectorSyncStates = (syncStates: Record<string, ConnectorSyncStatus>) => {
  store.commit('hydrateConnectorSyncStates', syncStates);
};
